import { CircularProgress } from '@mui/material';
import React, { useEffect, useState } from 'react';

const loadingMessages = [
  'Processing your request...',
  'Please wait a moment...',
  'Analyzing information...',
  'Retrieving data...',
  'Loading resources...',
  'Working on it...',
  'Thinking...',
  'Just a moment...',
  'Almost there...',
];

export default function Loader({
  fullscreen,
  size = 40,
  messages = loadingMessages,
  showMessage = false,
}) {
  const [messageIndex, setMessageIndex] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setMessageIndex((prevIndex) => {
        let newIndex;
        do {
          newIndex = Math.floor(Math.random() * loadingMessages.length);
        } while (loadingMessages.length > 1 && newIndex === prevIndex);
        return newIndex;
      });
    }, 3500);

    // Clear the interval when the component unmounts or isLoading becomes false
    return () => clearInterval(intervalId);
  }, []);

  if (fullscreen) {
    return (
      <div className="flex justify-center items-center h-screen ">
        <CircularProgress />
      </div>
    );
  }
  return (
    <div className="flex flex-col justify-center items-center">
      <CircularProgress size={size} />
      {showMessage && (
        <p className="mt-4 font-semibold text-center px-4">{messages[messageIndex]}</p>
      )}
    </div>
  );
}
